import { createTheme as createThemeV4 } from '@mui/material/styles'

import palette from './palette'
import typography from './typography'
import overrides from './overrides'

export const themeV4 = createThemeV4({
  palette,
  typography,
  overrides,
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
})
